import {
    MessageQuestion,
    ClipboardTick,
    Card,
    DocumentText,
    ChemicalGlass,
    Headphone,
    Book1,
    Lock1,
    Profile2User,
} from '@/components/icons';
import { YoutubeLogoIcon } from '../components/YoutubeLogoIcon';
import type { HelpShortcut, HelpTopic } from '../types';

export const createHelpShortcuts = (supportUrl: string): HelpShortcut[] => [
    {
        id: 'youtube-tutorials',
        title: 'Tutoriais no YouTube',
        description: 'Assista a vídeos curtos sobre os principais fluxos do LaudoPsi.',
        icon: YoutubeLogoIcon,
        tone: 'youtube',
        statusLabel: 'Em breve',
        action: {
            type: 'disabled',
        },
    },
    {
        id: 'support',
        title: 'Suporte',
        description: 'Abra um chamado para dúvidas da conta, erros ou investigação técnica.',
        icon: Headphone,
        tone: 'info',
        action: {
            type: 'internal',
            to: supportUrl,
        },
    },
];

export const HELP_TOPICS: HelpTopic[] = [
    {
        id: 'getting-started',
        title: 'Primeiros passos',
        description:
            'Configure sua conta, conheça o painel e encontre os fluxos essenciais para começar com segurança.',
        icon: MessageQuestion,
        tone: 'brand',
        keywords: ['início', 'onboarding', 'painel', 'configurar conta'],
    },
    {
        id: 'reports',
        title: 'Laudos',
        description:
            'Crie, revise, personalize, exporte e acompanhe laudos psicológicos dentro do editor.',
        icon: DocumentText,
        tone: 'info',
        keywords: ['laudo', 'relatório', 'pdf', 'editor', 'modelo'],
    },
    {
        id: 'patients',
        title: 'Pacientes',
        description:
            'Organize cadastros, acompanhe histórico e mantenha dados clínicos protegidos.',
        icon: Profile2User,
        tone: 'success',
        keywords: ['paciente', 'cadastro', 'histórico', 'dados'],
    },
    {
        id: 'tests',
        title: 'Testes e formulários',
        description:
            'Envie instrumentos, colete respostas e use resultados como apoio para a produção do laudo.',
        icon: ClipboardTick,
        tone: 'warning',
        keywords: ['teste', 'formulário', 'resposta', 'avaliação', 'enviar'],
    },
    {
        id: 'assets',
        title: 'Instrumentos',
        description:
            'Consulte, organize e reutilize recursos avaliativos, escalas e materiais de apoio.',
        icon: Book1,
        tone: 'brand',
        keywords: ['instrumentos', 'materiais', 'biblioteca', 'escala'],
    },
    {
        id: 'tools',
        title: 'Calculadoras',
        description:
            'Use ferramentas clínicas e cálculos auxiliares sem sair do fluxo de trabalho.',
        icon: ChemicalGlass,
        tone: 'info',
        keywords: ['calculadora', 'ferramenta', 'score', 'pontuação'],
    },
    {
        id: 'billing',
        title: 'Assinatura',
        description: 'Entenda planos, limites, faturas e como acompanhar o uso da sua assinatura.',
        icon: Card,
        tone: 'success',
        keywords: ['assinatura', 'plano', 'pagamento', 'fatura', 'limite'],
    },
    {
        id: 'privacy',
        title: 'Privacidade e LGPD',
        description:
            'Boas práticas para proteger dados sensíveis de pacientes ao usar a plataforma.',
        icon: Lock1,
        tone: 'warning',
        keywords: ['privacidade', 'lgpd', 'segurança', 'dados', 'paciente'],
    },
];
